<div class="lightning-game" [ngClass]="getIntensityClass()">
  <!-- Header -->
  <div class="game-header">
    <span class="question-counter">
      <span class="current">{{ getQuestionNum() | arabicNumber:currLang }}</span>
      <span class="sep">/</span>
      <span class="total">{{ getTotalQuestions() | arabicNumber:currLang }}</span>
    </span>
    <span class="game-title">&#9889; {{ currLang === 'ar' ? 'الجولة الخاطفة' : 'Lightning Round' }}</span>
    <div class="header-actions">
      <app-game-sound-control></app-game-sound-control>
      <button class="header-action-btn help-btn" (click)="showInfo = true">
        <span class="help-icon">?</span>
      </button>
    </div>
  </div>
  <app-game-info-modal *ngIf="showInfo" [gameType]="'lightning_round'" (close)="showInfo = false"></app-game-info-modal>

  <!-- Combo Meter -->
  <app-combo-meter
    [comboCount]="state?.comboCount || 0"
    [multiplier]="state?.comboMultiplier || 1"
    [intensity]="state?.intensity || 0"
    [currLang]="currLang">
  </app-combo-meter>

  <!-- Student Spotlight -->
  <app-student-spotlight
    *ngIf="showingStudent && currentStudent"
    [student]="currentStudent"
    [currLang]="currLang"
    [label]="currLang === 'ar' ? 'يجيب على السؤال!' : 'Answers the question!'">
  </app-student-spotlight>

  <!-- Timer bar -->
  <div class="timer-bar" *ngIf="!showingStudent">
    <app-quiz-timer [value]="timerValue" [max]="10" [currLang]="currLang"></app-quiz-timer>
  </div>

  <!-- Current student indicator -->
  <div class="current-student-bar" *ngIf="currentStudent && !showFlash && !showingStudent">
    <app-student-avatar [student]="currentStudent" [size]="40" [active]="true"></app-student-avatar>
    <span class="current-student-name">{{ getCurrentStudentName() }}</span>
  </div>

  <!-- Question (tap to answer, no submit button) -->
  <div class="question-area" *ngIf="currentQuestion && !showFlash && !showingStudent">
    <app-question-card
      [question]="currentQuestion"
      [selectedOption]="selectedOption"
      (optionSelected)="selectOption($event)">
    </app-question-card>
    <div class="tap-hint">{{ currLang === 'ar' ? 'انقر للإجابة فوراً!' : 'Tap to answer instantly!' }}</div>
  </div>

  <!-- Flash result -->
  <div class="flash-overlay" *ngIf="showFlash" [class.correct]="flashCorrect" [class.incorrect]="!flashCorrect">
    <span class="flash-icon">{{ flashCorrect ? '&#9889;' : '&#10008;' }}</span>
    <span class="flash-text" *ngIf="flashCorrect">{{ currLang === 'ar' ? 'سريع!' : 'FAST!' }}</span>
    <span class="flash-text" *ngIf="!flashCorrect">{{ currLang === 'ar' ? 'خطأ' : 'MISS' }}</span>
  </div>
</div>
